import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/client.js";
import { useI18n } from "../i18n/I18nContext.jsx";
import { useAuth } from "../context/AuthContext.jsx";
import ZoneForm from "../components/ZoneForm.jsx";
import "../styles/Zones.css";

export default function Zones() {
  const { t } = useI18n();
  const { user } = useAuth();
  const navigate = useNavigate();
  const [zones, setZones] = useState([]);
  const [showAdd, setShowAdd] = useState(false);
  const isAdmin = user?.role === "SUPER_ADMIN" || user?.role === "CORP_ADMIN";

  const fetchZones = () => {
    api.get("/zones/").then((r) => setZones(r.data.results || r.data));
  };

  useEffect(() => {
    fetchZones();
  }, []);

  return (
    <div className="page-zones">
      <div className="page-header" style={{ display: "flex", justifyContent: "flex-end", alignItems: "center", marginBottom: "1.5rem" }}>
        {isAdmin && (
          <button className="btn btn-primary" onClick={() => setShowAdd(true)}>
            + {t("addZone")}
          </button>
        )}
      </div>

      <div className="zones-grid">
        {zones.map((z) => (
          <div
            key={z.id}
            onClick={() => navigate(`/zones/${z.id}`)}
            className="zone-card"
          >
            <div className="zone-card-header">
              <h3 className="zone-card-title">{z.name}</h3>
              <span className="tag-pill">{z.code}</span>
            </div>
            
            <div className="zone-card-body">
              <div className="zone-info-item">
                <i className="ti ti-phone"></i>
                <span>{z.cug_number || "—"}</span>
              </div>
              <div className="zone-info-item">
                <i className="ti ti-building"></i>
                <span>{z.ac_office || "—"}</span>
              </div>
            </div>

            <div className="zone-card-footer">
              <span className="zone-card-footer-label">{t("activeParas")}</span>
              <span className={`zone-paras-badge ${z.para_count > 0 ? "has-paras" : "no-paras"}`}>
                {z.para_count ?? 0}
              </span>
            </div>
          </div>
        ))}
      </div>
      {showAdd && (
        <ZoneForm
          onClose={() => setShowAdd(false)}
          onSuccess={() => {
            setShowAdd(false);
            fetchZones();
          }}
        />
      )}
    </div>
  );
}
